export default __webpack_public_path__ + "imgs/toLove.09f7155.jpeg";